module.exports = __webpack_public_path__ + "static/media/footer__logo-adsigo.02c20e37.png";